import React, { useContext } from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import {getTrackMetadataValue} from './utility/MetadataFetcher';
import { WalkDataContext } from './hooks/walkDataContext';


const TrackDetails = ({currentTrack___, metas__, language__}) => {

const { currentTrack, storyMetas, language} = useContext(WalkDataContext);
const trackTitle = getTrackMetadataValue(currentTrack, storyMetas, language, 'trackMeta_name', 'trackMeta_name', '-- ohne Titel --');
const trackAuthor = getTrackMetadataValue(currentTrack, storyMetas, 1, 'trackMeta_author', 'storyMeta_author', '');
const trackCover = getTrackMetadataValue(currentTrack, storyMetas, language, 'trackMeta_cover', 'storyMeta_cover', '/assets/illustrations/placeholder-cover.jpg');
const trackDescription = getTrackMetadataValue(currentTrack, storyMetas, language, 'trackMeta_description', 'storyMeta_description', '', true);

  return (
    <div className="card-container">
      <Card>
        <Card.Img variant="top" src={trackCover} alt={`${trackTitle} Coverbild`} className='card-coverimage'  /><br />
        <Card.Body>
          {trackAuthor && <Card.Text>
            <span className='track-description story-author'> {trackAuthor} </span>
          </Card.Text>}
          <Card.Title as="h1" className="title-page title-trackdetails">{trackTitle}</Card.Title>
          {trackDescription && <Card.Text>
            <span className='track-description' dangerouslySetInnerHTML={trackDescription} />
          </Card.Text>}
        </Card.Body>
      </Card>
      <div className='miniplayer-spacer'></div>
      <div className='navmenu-spacer'></div>
      
    </div>
    
  );
};

export default TrackDetails;
